export type SearchParamValue = string | number | boolean | undefined;

export type RouterSearchParams = Record<string, string | undefined>;

export interface NavigationTarget {
  to: string;
  params?: Record<string, string>;
  search?: Record<string, SearchParamValue>;
}

export interface NavigationItem {
  id: string;
  label: string;
  abbr: string;
  description?: string;
  icon?: string;
  target: NavigationTarget;
  disabled?: boolean;
  children?: NavigationItem[];
}

export const mainNavigation: NavigationItem[] = [
  {
    id: "home",
    label: "Home",
    abbr: "HM",
    icon: "home",
    description: "See what's new",
    target: {
      to: "/home",
    },
  },
  // TODO: Add collections back in when we have a use case for them
  // {
  //   id: "collections",
  //   label: "Collections",
  //   abbr: "CL",
  //   icon: "layers",
  //   description: "Organize intelligence collections",
  //   target: {
  //     to: "/collections",
  //   },
  // },
];

export { getCategoriesNavigation } from "@/features/categories";

export const adminNavigation: NavigationItem[] = [
  {
    id: "admin-users",
    label: "Users",
    abbr: "US",
    icon: "users",
    description: "Manage platform accounts & roles",
    target: {
      to: "/admin",
      search: {
        panel: "users",
      },
    },
  },
  {
    id: "admin-categories",
    label: "Categories",
    abbr: "CT",
    icon: "layers",
    description: "Organize race intelligence groupings",
    target: {
      to: "/admin",
      search: {
        panel: "categories",
      },
    },
  },
  {
    id: "admin-attributes",
    label: "Attributes",
    abbr: "AT",
    icon: "sliders",
    description: "Define telemetry attribute templates",
    target: {
      to: "/admin",
      search: {
        panel: "attributes",
      },
    },
  },
  {
    id: "admin-tags",
    label: "Tags",
    abbr: "TG",
    icon: "tag",
    description: "Curate metadata tags & labels",
    target: {
      to: "/admin",
      search: {
        panel: "tags",
      },
    },
  },
  {
    id: "admin-job-postings",
    label: "Job Postings",
    abbr: "JP",
    icon: "briefcase",
    description: "Monitor crawl activity and job postings",
    target: {
      to: "/admin",
      search: {
        panel: "job-postings",
      },
    },
  },
  {
    id: "admin-core-signal",
    label: "Core Signal",
    abbr: "CS",
    icon: "radio",
    description: "Core Signal dashboard and configuration",
    target: {
      to: "/admin",
      search: {
        panel: "core-signal-dashboard",
      },
    },
    children: [
      {
        id: "admin-core-signal-dashboard",
        label: "Dashboard",
        abbr: "CSD",
        icon: "layout-dashboard",
        description: "Monitor core signal system status and metrics",
        target: {
          to: "/admin",
          search: {
            panel: "core-signal-dashboard",
          },
        },
      },
      {
        id: "admin-core-signal-companies",
        label: "Companies",
        abbr: "CSC",
        icon: "building",
        description: "Manage companies and their configurations",
        target: {
          to: "/admin",
          search: {
            panel: "core-signal-companies",
          },
        },
      },
      {
        id: "admin-core-signal-configuration",
        label: "Configuration",
        abbr: "CSC",
        icon: "settings",
        description: "Configure core signal parameters and settings",
        target: {
          to: "/admin",
          search: {
            panel: "core-signal-configuration",
          },
        },
      },
    ],
  },
];
